import React, { useEffect, useState,useCallback } from 'react';
import store from '../../stateManagement/store';
import ReportAndLogsRow from './reportAndLogsRow';
import { LogEntity } from './reportAndLogsRowTypes';
import { logsPerPage, dropDownElements } from './constant';
import { MenuItem, Select } from '@mui/material';
import './Logs.css';
import Paginations from '@mui/material/Pagination';
import { DomainValue, DomainValueConfig } from '../../services/mdmService/types';
import { mdmRegistry } from '../../features/mdm/mdmRegistry';
import { getMetaDataConfig } from '../../services/uiConfigService';
import BackButton from '../Buttons/BackButton/BackButton';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import { ChannelkartNetworkGet } from '../../services/networkService';


const CUR_COMPONENT = "Report And Logs"
const CUR_COMPONENT_COMMON="commonPortal";
const ReportAndLogs = () => {
    const {translate}=usePortalTranslation();
    const [curData, setData] = useState<LogEntity[]>([]);
    const [entity, setEntity] = useState<string>(store.getState().mdmReducer.entity ? store.getState().mdmReducer.entity : "All");
    const [dropDownOptions,setDropDownOptions] = useState<string[]>([...dropDownElements]);
    const [currentPage, setCurrentPage] = useState<number>(1);

    const getLogs = useCallback(async () => {
        const serviceRegistry = store?.getState()?.serviceRegistry;
        const Url = getUrl(entity);
        const entityData = await ChannelkartNetworkGet(Url);
        const logs = entityData.data.features.filter((log: any) => 
            log.response !== undefined || log.attributes?.entityName === "promoentity"
        );        
        setData(logs);
    },[entity]);

    function getUrl(entity: string) {
        if (entity && entity !== "All") {
            return `/tasks/data?filter=type[in]:['blobcreater','mdmupload','mdmkafkaupload'] and attributes.entityName:${entity}&sort=creationTime:desc&size=100&source=portal&callType=scheduled`
        } else {
            return `/tasks/data?filter=type[in]:['blobcreater','mdmupload','mdmkafkaupload']&sort=creationTime:desc&size=100&source=portal&callType=scheduled`
        }
    }

    useEffect(() => {
        async function getAndSetDropDownElement(){
            const mdmConfig = await getMetaDataConfig("clientConfig","mdmConfig");
            if(mdmConfig && mdmConfig.domainValues){
                const newFilterOptions = mdmConfig.domainValues.map((option: DomainValueConfig) => {
                    const mdmRegistryObj = mdmRegistry.find((registryOption: DomainValue) => {
                        return option.id === registryOption.id;
                    })
                    if(mdmRegistryObj && mdmRegistryObj.entity){
                        return mdmRegistryObj.entity;
                    }else{
                        return option.id;
                    }
                })
                const uniqueFilterOptions = Array.from(new Set(newFilterOptions)) as string[];
                setDropDownOptions(uniqueFilterOptions);
            }else{
                setDropDownOptions(dropDownElements)
            }
        }
        getAndSetDropDownElement();
    },[])

    useEffect(() => {
        getLogs();
    },[getLogs]);

    const lastLogIndex = currentPage * logsPerPage - 1;
    const firstLogIndex = (currentPage - 1) * logsPerPage;
    const currentLog = curData.slice(firstLogIndex, lastLogIndex + 1);

    const changePageNumber = (event: React.ChangeEvent<unknown>, page: number) => {
        setCurrentPage(page);
    }

    const logsAndReportsPagination = ( totalLogs:number, LOGS_PER_PAGE:number) => {
        const numberOfPages = Math.ceil(totalLogs / LOGS_PER_PAGE);
        const pageNumbers = [];

        for (let i = 1; i <= numberOfPages; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    }
    return (
        <>
            <div className="reports-logs">
                <div className='report-logs-header'>
                    <Select defaultValue={entity} className="filter-btn">
                        {dropDownOptions.map((element: string) => {
                            return <MenuItem value={element} onClick={(e) => setEntity(element)} > {translate(TranslationEnum.report_and_logs, element)}</MenuItem>
                        })}
                    </Select>
                    <BackButton />
                </div>
                <div className="logs-body">
                    {currentLog.length > 0 ? currentLog.map((currentLog, index) => {

                        return (<ReportAndLogsRow
                                logIndex={index + firstLogIndex + 1}
                                id={currentLog?.id}
                                filePath={currentLog?.attributes?.filePath}
                                lastModifiedTime={currentLog?.lastModifiedTime}
                                status={currentLog?.response?.status}
                                summary={currentLog?.response?.info?.error && currentLog?.response?.info?.error[0] && currentLog?.response?.info?.error[0]?.summary}
                                description={currentLog?.response?.info?.error && currentLog?.response?.info?.error[0] && currentLog?.response?.info?.error[0]?.description}
                                statusReport={currentLog?.response?.info?.statusReport}
                                entityName={currentLog?.attributes?.entityName}
                                type={currentLog?.attributes?.type}
                                mdmType={currentLog?.type}
                            />);

                    }) : <div className="no-data-avail-msg"> {translate(TranslationEnum.common_portal,"No Data Available")} </div>

                    }
                </div>

                {currentLog.length > 0 ? <div className='pagination-bar' >
                <Paginations count={logsAndReportsPagination(curData.length,logsPerPage).length} page={currentPage} variant="outlined" onChange={changePageNumber} color="primary" />
                </div> : <></>
                }
            </div>

        </>
    );
}

export default ReportAndLogs;